import "./Tasks.css";
import DataTable from "../../../Components/DataTable/DataTable";
import { useNavigate } from "react-router-dom";
import PageHead from "../../../Components/PageHead/PageHead";
import { Get } from "../../../Services/Server";
import Url from "../../../Services/Url";
import User from "../../../Services/User";
import { useState, useEffect } from "react";
import AddTaskWizard from "../../../Modals/AddEnterpriseTaskModal/AddTaskWizard";
import AddPendingTaskWizard from "../../../Modals/AddPendingEnterpriseTask/AddTaskWizard";
import Time from "../../../Services/Time";

const TaskReader = (rec) => {
	return [
		rec.vesselName,
		rec.jobNumber,
		rec.companyName,
		rec.location,
		Time.getDate(rec.createdAt),
	];
};
const JobReader = (rec) => {
	return [
		rec.vessel,
		rec.equipment,
		rec.company,
		rec.port,
		Time.getDate(rec.createdAt),
	];
};

const TasksView = ({ navoption, ModalAction }) => {
	const userRoles = User.getRoles();
	const heading = ["Job Number", "Company", "Location", "Started on"];
	const jobHeading = ["Job", "Company", "Location", "Started on"];
	const Navigate = useNavigate();
	const [current, setCurrent] = useState({
		heading: ["Ongoing Tasks", ...heading],
	});
	const [previous, setPrevious] = useState({
		heading: ["Completed Tasks", ...heading],
	});
	const [pending, setPending] = useState({
		heading: ["Pending Tasks", ...jobHeading],
	});
	const [closed, setClosed] = useState({
		heading: ["Closed Tasks", ...jobHeading],

	});
	const [isSearching, setIsSearching] = useState(false);
	const [searchKeyword, setSearchKeyword] = useState("");
	const [view, setView] = useState("current");

	const loadPending = (pg) => {
		const searchQuery = searchKeyword ? `?q=${encodeURIComponent(searchKeyword)}` : "";
		Get(Url.sales.getAllEnterpriseInitDTO(true, pg) + searchQuery).then((resp) => {
			setPending({ ...pending, data: resp });
		}).catch((err) => {
			console.error("Error loading pending tasks:", err);
		});
	};

	const loadCurrent = (page) => {
		const searchQuery = searchKeyword ? `?q=${encodeURIComponent(searchKeyword)}` : "";
		Get(Url.enterprise.userTaskList(true, page) + searchQuery)
			.then((resp) => {
				setCurrent({ ...current, data: resp });
				console.log(resp);
			})
			.catch((err) => {
				console.error("Error loading current tasks:", err);
			});
	};

	const loadPrevious = (page) => {
		const searchQuery = searchKeyword ? `?q=${encodeURIComponent(searchKeyword)}` : "";
		Get(Url.enterprise.userTaskList(false, page) + searchQuery)
			.then((resp) => {
				setPrevious({ ...previous, data: resp });
				console.log(resp);
			})
			.catch((err) => {
				console.error("Error loading previous tasks:", err);
			});
	};

	const loadClosed = (page) => {
		const searchQuery = searchKeyword ? `?q=${encodeURIComponent(searchKeyword)}` : "";
		Get(Url.enterprise.closedTasks(page) + searchQuery)
			.then((resp) => {
				setClosed({ ...closed, data: resp });
			})
			.catch((err) => {
				console.error("Error loading closed tasks:", err);
			});
	};

	const loadData = (page) => {
		if (view === "current") {
			loadCurrent(page);
		} else if (view === "previous") {
			loadPrevious(page);
		} else if (view === "pending") {
			loadPending(page);
		} else if (view === "closed") {
			loadClosed(page);
		}
	};

	useEffect(() => {
		loadData(0);
	}, [view]);

	useEffect(() => {
		loadData(0);
	}, [searchKeyword]);

	const onTaskClick = (e) => {
		// if (userRoles.some(r => r.name === "account")) {
		// Navigate(`Expenses/${e.id}`);
		// }
		// else
		Navigate(`${e.id}`);
	};

	const flex = [20, 20, 20, 20, 20];
	const btns = navoption.controls();
	const handleTemplate = () => {
		Navigate("MilestoneTemplates");
	};
	const handleAddTask = () => {
		const Options = {
			title: "Add Task",
			element: AddTaskWizard,
			closeModal: (resp) => {
				loadData(0);
				ModalAction.closeModal();
			},
		};
		ModalAction.openModal(Options, "Add Task");
	};
	if (Array.isArray(btns)) {
		btns.forEach((btn) => {
			if (btn.id === 1) btn.onClick = handleTemplate;
			else if (btn.id === 4) btn.onClick = () => Navigate("report");
			else btn.onClick = handleAddTask;
		});
	}
	const handleNextCurrent = (page) => {
		loadCurrent(page);
	};
	const handleNextPending = (page) => {
		loadPending(page);
	};
	const handleNextPrevious = (page) => {
		loadPrevious(page);
	};
	const dropOptions = {
		onClick: (e) => {
			const op = e.find((o) => o.selected);
			if (!op) {
				setView("current");
			} else {
				if (op.text === "Ongoing Tasks") setView("current");
				else if (op.text === "Pending Tasks") setView("pending");
				else if (op.text === "Completed Tasks") setView("previous");
				else if (op.text === "Closed Tasks") setView("closed");
			}
		},
		list: [
			"Ongoing Tasks",
			...(userRoles.some(
				(r) =>
					r.base === "admin" ||
					r.base === "operation" ||
					r.base === "enterprise-ops"
			)
				? ["Pending Tasks"]
				: []),
			"Completed Tasks",
			"Closed Tasks",
		],
	};

	const handlePending = (e) => {
		const Options = {
			title: "Add Task",
			element: AddPendingTaskWizard,
			jobId: e.id,
			closeModal: (resp) => {
				loadData(0);
				ModalAction.closeModal();
			},
		};
		ModalAction.openModal(Options, "Add Task");
	};
	const onSearch = (keyword) => {
		setSearchKeyword(keyword.trim());
		setIsSearching(!!keyword.trim());
	};
	return (
		<div className="Tasks">
			<PageHead
				dropOptions={dropOptions}
				navoption={navoption}
				buttons={btns}
				onSearch={onSearch}
				title="Tasks"
				filter={"Ongoing Tasks"}
			></PageHead>
			<div className="CurrentTasks">
				{view === "current" && current.data && (
					<DataTable
						handlePagination={handleNextCurrent}
						reader={TaskReader}
						onClick={onTaskClick}
						flex={flex}
					>
						{current}
					</DataTable>
				)}
				{view === "pending" && pending.data && (
					<DataTable
						handlePagination={handleNextPending}
						reader={JobReader}
						onClick={handlePending}
						flex={flex}
					>
						{pending}
					</DataTable>
				)}
				{view === "previous" && previous.data && (
					<DataTable
						handlePagination={handleNextPrevious}
						reader={TaskReader}
						onClick={onTaskClick}
						flex={flex}
					>
						{previous}
					</DataTable>
				)}
				{view === "closed" && closed.data && (
					<DataTable
						handlePagination={handleNextPrevious}
						reader={TaskReader}
						onClick={onTaskClick}
						flex={flex}
					>
						{closed}
					</DataTable>
				)}
			</div>
		</div>
	);
};
export default TasksView;
